<template>
  <div class="manufacturing">
    <div class="left-side" ref="leftSide">
      <div class="search">
        <h1>Manufacturing</h1>
        <div class="search-with-fillter">
          <InputField
            v-model="searchCollection"
            placeholder="Search"
          >
            <template v-slot:start-icon>
              <svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" viewBox="0 0 20 21">
                <path fill="#09373d" d="M18 17.5 13.5 13c.9-1.1 1.4-2.5 1.4-4.1 0-3.6-3-6.6-6.6-6.6s-6.6 3-6.6 6.6c0 3.6 3 6.6 6.6 6.6 1.5 0 3-.5 4.1-1.4l4.5 4.5c.1.1.3.2.5.2s.4-.1.5-.2c.4-.4.4-.8.1-1.1zM3.2 8.8c0-2.8 2.3-5.1 5.1-5.1s5.1 2.3 5.1 5.1-2.3 5.1-5.1 5.1-5.1-2.3-5.1-5.1z"/>
              </svg>
            </template>
          </InputField>
          <ButtonSecondary class="small filter-mob-btn" @click.native="openMobFilter">
            <svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" viewBox="0 0 20 21">
              <path d="M17.5 13.8h-5.8c-.4 0-.8-.3-.8-.8s.3-.8.8-.8h5.8c.4 0 .8.3.8.8s-.4.8-.8.8zm-13.3 0H2.5c-.4 0-.8-.3-.8-.8s.3-.8.8-.8h1.7c.4 0 .8.3.8.8s-.4.8-.8.8z" class="st0"/>
              <path d="M6.2 15.8c-1.6 0-2.8-1.3-2.8-2.8s1.3-2.8 2.8-2.8C7.8 10.2 9 11.5 9 13s-1.2 2.8-2.8 2.8zm0-4.1c-.7 0-1.3.6-1.3 1.3s.6 1.3 1.3 1.3c.7 0 1.3-.6 1.3-1.3s-.5-1.3-1.3-1.3zm11.3-2.9h-.8c-.4 0-.8-.3-.8-.8s.3-.8.8-.8h.8c.4 0 .8.3.8.8s-.4.8-.8.8zm-9.2 0H2.5c-.4 0-.7-.4-.7-.8s.3-.8.8-.8h5.8c.4 0 .8.3.8.8s-.5.8-.9.8z" class="st0"/>
              <path d="M13.8 10.8C12.2 10.8 11 9.5 11 8c0-1.6 1.3-2.8 2.8-2.8s2.8 1.3 2.8 2.8c0 1.6-1.3 2.8-2.8 2.8zm0-4.1c-.7 0-1.3.6-1.3 1.3 0 .7.6 1.3 1.3 1.3s1.3-.6 1.3-1.3c0-.7-.6-1.3-1.3-1.3z" class="st0"/>
            </svg>
          </ButtonSecondary>

        </div>
      </div>
      <!-- <div>
        <button :class="['btn-group', selectedTab === 'factories' ? 'active' : '']" @click="selectedTab = 'factories'">Factories</button>
        <button disable :class="['btn-group', selectedTab === 'textiles' ? 'active' : '']" @click="selectedTab = 'textiles'">Textiles</button>
        <button disable :class="['btn-group', selectedTab === 'trims' ? 'active' : '']" @click="selectedTab = 'trims'">Trims</button>
      </div> -->
      <div style="display: flex; margin-top:24px;">
        <div class="letter" v-if="clickCount > 0" @click="clickCount--" style="margin-right: 12px;">
          <svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" viewBox="0 0 20 20" width="20" height="20">
            <path fill="#09373d" d="M11.7 5.9c.2 0 .4.1.5.2.3.3.3.8 0 1.1L9.4 10l2.8 2.8c.3.3.3.8 0 1.1s-.8.3-1.1 0l-3.3-3.3c-.1-.1-.2-.3-.2-.5s.1-.4.2-.5l3.3-3.3c.2-.3.4-.4.6-.4z"/>
          </svg>
        </div>
        <div class="letters-cont" :style="`width:${letterWidth}px;`">
          <div class="letters" :style="`transform: translateX(-${clickCount * 52 - (lastClick ? 52 : 0)}px); width:${letterWidth - 52}px;`">
            <a :href="'#' + letter" class="letter" v-for="letter in manufacturingStore.factoriesLetters" :key="letter">{{letter}}</a>
          </div>
        </div>
        <div class="letter" v-if="!lastClick" @click="clickCount++" style="margin-left: 12px;">
          <svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" viewBox="0 0 20 20" width="20" height="20">
            <path fill="#09373d" d="M8.3 14.1c-.2 0-.4-.1-.5-.2-.3-.3-.3-.8 0-1.1l2.8-2.8-2.8-2.8c-.3-.3-.3-.8 0-1.1s.8-.3 1.1 0l3.3 3.3c.1.1.2.3.2.5s-.1.4-.2.5l-3.3 3.3c-.2.3-.4.4-.6.4z"/>
          </svg>
        </div>
      </div>
      <div class="info">
        <template v-if="columns[0].length">
          <div
            class="info__column"
            v-for="(col, ci) in columns"
            :key="ci"
          >
              <div
                class="info__item"
                :id="letter"
                v-for="letter in col"
                :key="letter"
              >
                {{ letter }}
                <div class="line"/>
                <p
                  class="item"
                  v-for="item in manufacturingStore.factoriesList[letter]"
                  :key="item.id"
                  @click="$router.push(`/user/manufacturing/${item.id}`)"
                >
                  {{item.brandName}}
                </p>
              </div>
          </div>
        </template>
        <div v-else class="not-found">
          <div class="not-found__svg">
            <svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" viewBox="0 0 32 32" width="32" height="32">
              <path d="M13.3 23.4c-5.6 0-10.1-4.5-10.1-10.1S7.7 3.2 13.3 3.2s10.1 4.5 10.1 10.1-4.5 10.1-10.1 10.1zm0-18.6c-4.7 0-8.6 3.9-8.6 8.6 0 4.7 3.9 8.6 8.6 8.6s8.6-3.9 8.6-8.6c0-4.8-3.8-8.6-8.6-8.6z"/>
              <path d="M28 28.8c-.2 0-.4-.1-.5-.2l-8-8c-.3-.3-.3-.8 0-1.1s.8-.3 1.1 0l8 8c.3.3.3.8 0 1.1-.2.1-.4.2-.6.2z"/>
            </svg>
          </div>
          <p class="not-found__title">Nothing found...</p>
          <p class="not-found__desc">Try editing your filters or your query</p>
        </div>
      </div>
    </div>
    <div class="right-side">
      <div class="filtered">
        <h4>Filtered by</h4>
        <div :class="`clear-all ${!Object.keys(sendedFilter).length ? 'disabled' : ''}`" @click="clearFilter">
          Clear all
        </div>
      </div>
      <Multiselect
        v-for="item in filtersItems"
        :key="item.key"
        v-model="item.value"
        @change="inputFilter($event, item)"
        :label="item.label"
        :options="manufacturingStore.factoriesFilters[item.key]"
        :showCount="3" />
    </div>
    <ModalComponent
      :show="isShowMobFilter"
      @close="closeMobFilter"
      :showIcon="false"
    >
      <template v-slot:extra>
        <h4>Filtered by</h4>
        <Multiselect
          v-for="item in filtersItems"
          :key="item.key"
          v-model="newMobFilter[item.key]"
          :label="item.label"
          :options="manufacturingStore.factoriesFilters[item.key]"
          :showCount="3" />
      </template>
      <template v-slot:buttons>
        <div class="clear-all" @click="clearMobFilter" v-if="isShowFilterButton">Clear all</div>
        <ButtonPrimary :disabled="isDisableSendFilterButton" class="small filter-mob-btn" @click.native="sendFilter">
          Apply
        </ButtonPrimary>
      </template>
    </ModalComponent>
  </div>
</template>

<script>
import InputField from '@/components/Atoms/InputField.vue'
import Multiselect from '@/components/Atoms/Multiselect.vue'
import ButtonSecondary from '@/components/Atoms/ButtonSecondary.vue'
import ButtonPrimary from '@/components/Atoms/ButtonPrimary.vue'
import ModalComponent from '@/components/Atoms/ModalComponent'

import { mapStores } from 'pinia'
import { useManufacturingStore } from '@/store/pinia/manufacturing'

export default {
  name: 'manufacturing',
  components: {
    InputField,
    Multiselect,
    ButtonPrimary,
    ButtonSecondary,
    ModalComponent,
  },
  data: () => ({
    search: '',
    selectedTab: 'factories',
    locations: [],
    pricePoints: [],
    isShowMobFilter: false,
    windowWidth: window.innerWidth,
    filtersItems: [
      { key: 'locations', label: 'Locations', value: [] },
      { key: 'sewnGoodsServices', label: 'Sewn goods services', value: [] },
      { key: 'pricePoints', label: 'Price points', value: [] },
      { key: 'categories', label: 'Categories', value: [] },
      { key: 'products', label: 'Manufactured goods', value: [] },
      { key: 'jewelryServices', label: 'Jewelry Services', value: [] },
      { key: 'productionMinimums', label: 'Production minimum', value: [] },
    ],
    searchTimer: null,
    sendedFilter: {},
    newMobFilter: {
      locations: [],
      sewnGoodsServices: [],
      pricePoints: [],
      categories: [],
      products: [],
      jewelryServices: [],
      productionMinimums: [],
    },
    widthleftSide: 0,
    clickCount: 0,
  }),
  computed: {
    count () {
      let width = 0
      let windowWidth = this.windowWidth
      if (this.windowWidth > 1440) windowWidth = 1440
      if (this.windowWidth > 1150) width = windowWidth - 297 - 250 + 12
      else if (this.windowWidth > 768) width = windowWidth - 297 + 12
      else width = this.windowWidth - 32 + 12
      return Math.floor(width / 52)
    },
    lastClick () {
      let allCount = this.manufacturingStore?.factoriesLetters?.length
      if ((allCount - this.count - this.clickCount + 1) < 0) return true
      return false
    },
    letterWidth () {
      let count
      if (this.lastClick) count = this.count - 1
      else if (this.clickCount > 0) count = this.count - 2
      else count = this.count - 1
      return count * 52 - 12
    },
    isShowFilterButton () {
      let isShow = false
      for (let key in this.newMobFilter) {
        if (this.newMobFilter[key].length) isShow = true
      }
      return isShow
    },
    isDisableSendFilterButton () {
      let disable = true
      for (let key in this.newMobFilter) {
        if (this.newMobFilter[key].length) {
          if (
            !this.sendedFilter[key] ||
            this.sendedFilter[key] !== this.newMobFilter[key]?.toString()
          ) disable = false
        } else if (this.sendedFilter[key]) disable = false
      }
      return disable
    },
    searchCollection: {
      get () {
        return this.search
      },
      set (value) {
        this.search = value
        clearTimeout(this.searchTimer)
        this.searchTimer = window.setTimeout(async () => {
          this.sendedFilter.q = value
          if (!value) delete this.sendedFilter.q
          await this.manufacturingStore.getFactories(this.sendedFilter)
        }, 500)
      },
    },
    ...mapStores(useManufacturingStore),
    columnsCount () {
      if (this.windowWidth <= 480) return 1
      else if (this.windowWidth <= 860) return 2
      else return 3
    },
    columns () {
      if (this.manufacturingStore.factoriesLetters) {
        const cols = Array.from({ length: this.columnsCount }, () => [])
        const heights = Array(this.columnsCount).fill(0)
        this.manufacturingStore.factoriesLetters.forEach(it => {
          const idx = heights.indexOf(Math.min(...heights))
          cols[idx].push(it)
          heights[idx] += it.estimatedHeight || 100
        })
        return cols
      } else return []
    },
  },
  methods: {
    async clearFilter () {
      this.sendedFilter = {}
      await this.manufacturingStore.getFactories(this.sendedFilter)
      this.filtersItems.forEach(el => { el.value = [] })
    },
    clearMobFilter () {
      for (let key in this.newMobFilter) {
        if (this.newMobFilter[key].length) this.newMobFilter[key] = []
      }
    },
    async sendFilter () {
      for (let key in this.newMobFilter) {
        if (this.newMobFilter[key].length) this.sendedFilter[key] = this.newMobFilter[key].toString()
      }
      await this.manufacturingStore.getFactories(this.sendedFilter)
      this.closeMobFilter()
    },
    closeMobFilter () {
      this.isShowMobFilter = false
      this.clearMobFilter()
    },
    openMobFilter () {
      this.isShowMobFilter = true
      for (let key in this.sendedFilter) this.newMobFilter[key] = this.sendedFilter[key].split(",")
    },
    async inputFilter (target, filter) {
      if (!target.length) delete this.sendedFilter[filter.key]
      else this.sendedFilter[filter.key] = target.toString()
      await this.manufacturingStore.getFactories(this.sendedFilter)
    },
    onResize () {
      this.windowWidth = window.innerWidth
    },
  },
  mounted () {
    window.addEventListener('resize', this.onResize)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.onResize)
  },
  async beforeMount () {
    this.manufacturingStore.getFactories()
  },
}
</script>

<style lang="scss">

.manufacturing {
  padding: 0 40px;
  display: flex;
  justify-content: space-between;
  .modal-component-overlay .modal-component {
    .buttons {
      button {
        min-width: 200px;
      }
      .clear-all {
        font-weight: 600;
        font-size: 14px;
      }
    }
    p {
      color: var(--Text-Text_Primary);
    }
  }
  h4 {
    color: var(--Text-Text_Primary);
    font-family: Unbounded;
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: 150%;
    margin-bottom: 16px;
  }
  .left-side {
    padding-right: 40px;
    width: 100%;
    .letter {
      min-width: 40px;
      padding: 10px 0;
      border-radius: 8px;
      border: 1px solid var(--Dividers);
      background: var(--Background);
      font-size: 14px;
      font-weight: 600;
      cursor: pointer;
      display: flex;
      justify-content: center;
    }
    .letters-cont {
      display: flex;
      overflow: hidden;
      .letters {
        display: flex;
        gap: 12px;
      }
    }
  }
  .right-side {
    padding-left: 40px;
    min-width: 250px;
    width: 250px;
    border-left: 1px solid var(--Dividers);
    .filtered {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      justify-content: space-between;
      .clear-all.disabled {
        opacity: 1;
        color: var(--Button-States-Disabled_Txt);
      };
      .clear-all {
        margin-bottom: 16px;
        font-size: 14px;
        cursor: pointer;
        &:hover {
          color: var(--Button-States-Disabled_Txt);
        }
      }
    }
    .check-title {
      color: var(--Basic-Black);
      font-size: 16px;
      font-style: normal;
      font-weight: 600;
      line-height: 20px;
      margin-bottom: 16px;
    }
  }
  .info {
    display: flex;
    gap: 40px;
    margin-top: 40px;
    .not-found {
      align-items: center;
      margin-top: 16px;
      &__svg {
        width: 88px;
        height: 88px;
        border-radius: 1000px;
        background: var(--Dividers);
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 24px;
      }
      &__title {
        color: var(--Text-Text_Primary);
        font-family: Unbounded;
        font-size: 18px;
        font-weight: 600;
        margin-bottom: 8px;
      }
      &__desc {
        color: var(--Text-Text_Secondary);
        font-size: 16px;
        margin-bottom: 0;
      }
    }
    &__column {
      flex: 1;
      display: flex;
      flex-direction: column;
      gap: 40px;
    }

    &__item {
      box-sizing: border-box;
      background: var(--Surface);
      padding: 16px;
      border-radius: 12px;
      border: 1px solid var(--Dividers);
      color: var(--Primary-Shades-Primary);
      font-size: 14px;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
      .word {
        color: var(--Text-Text_Primary);
        font-family: Unbounded;
        font-size: 56px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
      }
      .item {
        cursor: pointer;
        font-weight: 400;
      }
      .line {
        height: 1px;
        width: 100%;
        background: var(--Dividers);
        margin: 16px 0;
      }
    }
  }
  .btn-group {
    width: auto;
    height: 40px;
    padding: 0 25px;
    box-sizing: border-box;
    border: 1px solid var(--Dividers);
    background: var(--Background);
    color: var(--Text-Text_Secondary);

    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;

    &:first-child {
      border-top-left-radius: 8px;
      border-bottom-left-radius: 8px;
    }
    &:last-child {
      border-top-right-radius: 8px;
      border-bottom-right-radius: 8px;
    }

    &.active {
      border-color: var(--Active-State-Strokes);
      color: var(--Active-State-Strokes);
    }
  }
  .search {
    margin-bottom: 16px;
    h1 {
      color: var(--Text-Text_Primary);
      font-family: Unbounded;
      font-size: 25px;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
      margin: 0;
    }
    .search-with-fillter {
      max-width: 185px;
      display: flex;
      align-items: center;
      gap: 8px;
      .filter-mob-btn {
        display: none;
      }
    }
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 8px;
  }
}
@media (max-width: 1150px) {
  .manufacturing {
    .search .search-with-fillter {
      max-width: 250px;
      .filter-mob-btn {
        display: block;
      }
    }
    .right-side {
      display: none;
    }
    .left-side {
      padding-right: 0;
      width: 100%;
    }
    .info {
      gap: 16px;
      &__column {
        gap: 16px;
      }
    }
  }
}
@media (max-width: 760px) {
  .manufacturing {
    padding: 0;
  }
}
@media (max-width: 480px) {
  .manufacturing {
    .search {
      flex-direction: column;
      align-items: baseline;
      gap: 16px;
      .search-with-fillter {
        width: 100%;
        max-width: 100%;
      }
      h1 {
        font-size: 24px;
      }
    }
    .btn-group {
      width: calc(100% / 3);
    }
  }
}
</style>
